import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";

import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "../../../../config/config";

const expinyearsOptions = [
  {
    name: "",
  },
  {
    name: "Months",
  },
  {
    name: "Years",
  },
];

const ContactusBanner = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [exptabshow, setExptabshow] = useState(false);
  const [addressLine1, setaddressLine1] = useState("");
  const [addressLine2, setaddressLine2] = useState("");
  const [number, setnumber] = useState("");
  const [email, setemail] = useState("");
  const [type, settype] = useState("Add");
  const [googleMapUrl, setgoogleMapUrl] = useState("");
  const [textline1err, settextline1err] = useState("");
  const [addressNumber, setaddressNumber] = useState("");
  const [title, settitle] = useState("");
  const [link, setlink] = useState("");
  const [linkerr, setlinkErr] = useState("");
  const [headOffice, setheadOffice] = useState("");
  const [bannerimg, setbannerimg] = useState("");
  const [bannerimgerr, setbannerimgErr] = useState("");
  const [bannerimgnotpresent, setbannerimgnotpresent] = useState("");

  const [mbbannerimg, setmbbannerimg] = useState("");
  const [mbbannerimgerr, setmbbannerimgErr] = useState("");
  const [mbImgNotPresent, setmbImgNotPresent] = useState("");

  const [updateModel, setUpdateModel] = useState(false);
  const [showMobImg, setShowMobImg] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");

  const [bannerid, setbannerid] = useState("");

  const [toastlist, setToastList] = useState([]);

  const [titleErr, setTitleErr] = useState("");
  const [headErr, setHeadErr] = useState("");
  const [addLine1Err, setAddLine1Err] = useState("");
  const [addLine2Err, setAddLine2Err] = useState("");
  const [addNumErr, setAddNumErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [numberErr, setNumberErr] = useState("");
  const [urlErr, setUrlErr] = useState("");
  const azure_object_url = config.azure_object_url;

  let toastProperties = null;

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Contact detail ${
            updateModel ? "updated" : "added"
          } Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "Contact detail Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setUpdateModel(false);
    setShow(true);
    setShowMobImg(false);
    setShowDesktopImg(false);
    setaddressLine1("");
    setaddressLine2("");
    setemail("");
    setnumber("");
    setgoogleMapUrl("");
    settype("Add");
    //settextline1("");
    settitle("");
    setheadOffice("");
    setaddressNumber("");
    setlink("");
    setbannerimg("");
    setmbbannerimg("");
    setTitleErr("");
    setHeadErr("");
    setAddLine1Err("");
    setAddLine2Err("");
    setAddNumErr("");
    setEmailErr("");
    setNumberErr("");
    setUrlErr("");
  };

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getBannerImages");
    axios({
      method: "get",
      url: `${config.api_url}contactus/details`,
      //withCredentials: true,
    })
      .then((response) => {
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });
  }, []);

  const handleShowForUpdate = (rowData) => {
    console.log(rowData);
    setUpdateModel(true);
    setShow(true);
    //settextline1(rowData.text)
    settype("Update");
    setlink(rowData.buttonLink);
    setaddressLine1(rowData.addressLine1);
    setaddressLine2(rowData.addressLine2);
    setemail(rowData.email);
    setnumber(rowData.number);
    setgoogleMapUrl(rowData.googleMapUrl);
    settitle(rowData.title);
    setheadOffice(rowData.headOffice);
    setaddressNumber(rowData.addressNumber);
    setbannerid(rowData._id);

    setShowMobImg(false);
    setShowDesktopImg(false);
    setTitleErr("");
    setHeadErr("");
    setAddLine1Err("");
    setAddLine2Err("");
    setAddNumErr("");
    setEmailErr("");
    setNumberErr("");
    setUrlErr("");
  };

  const updateBanner = () => {
    var formData = new FormData();
    formData.append("addressLine1", addressLine1);
    formData.append("addressLine2", addressLine2);
    formData.append("email", email);
    formData.append("number", number);
    formData.append("googleMapUrl", googleMapUrl);
    formData.append("title", title);
    formData.append("headOffice", headOffice);
    formData.append("addressNumber", addressNumber);

    formData.append("screen", "home");

    if (mbImgNotPresent) {
      formData.append("mobileImageUrl", mbbannerimg);
      setmbImgNotPresent(false);
    }

    if (bannerimgnotpresent) {
      formData.append("desktopImageUrl", bannerimg);
      setbannerimgnotpresent(false);
    }

    let url = new URL(urldata + "admin/updateBannerImages");
    formData.append("id", bannerid);
    //url.searchParams.append('id', bannerid)
    var decoded = decodeURIComponent(url);

    axios({
      method: "post",
      url: `${config.api_url}contactus/details/update`,
      data: formData,
      //withCredentials: true,/banner/udpate
    })
      .then((response) => {
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        console.log("error--", error);
        setShow(false);
        // showToast("danger");
      });
  };

  const createbanner = () => {
    var formData = new FormData();
    formData.append("text", addressLine1);
    formData.append("title", title);
    formData.append("headOffice", headOffice);
    formData.append("addressNumber", addressNumber);
    formData.append("addressLine1", addressLine1);
    formData.append("addressLine2", addressLine2);
    formData.append("email", email);
    formData.append("number", number);
    formData.append("googleMapUrl", googleMapUrl);

    let url = new URL(urldata + "admin/addBannerImages");

    axios({
      method: "post",
      url: `${config.api_url}contactus/details/new`,
      data: formData,
      // withCredentials: true,
    })
      .then((response) => {
        // settextline1("");
        // settextline2("");
        // settextline3("");
        // setlink("");
        // setbannerimg("");
        // setmbbannerimg("");
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        // showToast("danger");
      });
  };

  const submit = () => {
    var formIsValid = true;

    if (!title) {
      formIsValid = false;
      setTitleErr("*Please fill office name.");
    } else {
      setTitleErr("");
    }

    if (!headOffice) {
      formIsValid = false;
      setHeadErr("*Please fill head office detail.");
    } else {
      setHeadErr("");
    }

    if (!addressLine1) {
      formIsValid = false;
      setAddLine1Err("*Please fill address line 1.");
    } else {
      setAddLine1Err("");
    }

    if (!addressLine2) {
      formIsValid = false;
      setAddLine2Err("*Please fill address line 2.");
    } else {
      setAddLine2Err("");
    }

    if (!addressNumber) {
      formIsValid = false;
      setAddNumErr("*Please fill address number.");
    } else {
      setAddNumErr("");
    }

    if (!email) {
      formIsValid = false;
      setEmailErr("*Please fill email detail.");
    } else {
      setEmailErr("");
    }

    if (!number) {
      formIsValid = false;
      setNumberErr("*Please fill number.");
    } else {
      setNumberErr("");
    }

    if (!googleMapUrl) {
      formIsValid = false;
      setUrlErr("*Please fill map url detail.");
    } else {
      setUrlErr("");
    }

    if (formIsValid) {
      if (updateModel) {
        updateBanner();
      } else {
        createbanner();
      }
    }
  };

  const deleteBtnClick = (id) => {
    setLoading(true);
    let data = {};
    data.id = id;

    let url = new URL(urldata + "admin/deleteBannerImage");

    axios({
      method: "post",
      url: `${config.api_url}contactus/details/delete`,
      data: data,
      // withCredentials: true,
    })
      .then((response) => {
        //   showToast("success");
        //   props.onHide(); props.history.push('/admin/login')

        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
        showToast("delete");
      })
      .catch((error) => {
        // showToast("danger");
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="addjobinlist text-right mb-4">
        <Button title="Add detail" onClick={handleShow} />
      </div>
      <MaterialTable
        title="Contact us Detail"
        columns={[
          { title: "Title", field: "title" },
          { title: "Head Office", field: "headOffice" },
          { title: "Address Line1", field: "addressLine1" },
          { title: "Address Line2", field: "addressLine2" },
          { title: "Address Number", field: "addressNumber" },
          { title: "Email", field: "email" },
          { title: "Number", field: "number" },
          { title: "Google Map Url", field: "googleMapUrl" },

          {
            field: "url",

            title: "Action  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title=" Update"
                  onClick={() => {
                    handleShowForUpdate(rowData);
                  }}
                ></Button>
                <Button
                  title=" Delete"
                  onClick={() => deleteBtnClick(rowData._id)}
                ></Button>
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />

      <Modal
        {...props}
        //   size="lg"
        //   aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="addbannerModel"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          <div className="title">{type} detail</div>

          <Row>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Title </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={title}
                onChange={(e) => settitle(e.target.value)}
                // maxlength="31"
                type="text"
              />

              <div className="err">{titleErr}</div>
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Head Office </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={headOffice}
                onChange={(e) => setheadOffice(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{headErr}</div>
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Address Line 1 </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={addressLine1}
                onChange={(e) => setaddressLine1(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{addLine1Err}</div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Address Line 2 </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={addressLine2}
                onChange={(e) => setaddressLine2(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{addLine2Err}</div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Address Number </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={addressNumber}
                onChange={(e) => setaddressNumber(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{addNumErr}</div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Email </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={email}
                onChange={(e) => setemail(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{emailErr}</div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} number </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={number}
                onChange={(e) => setnumber(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{numberErr}</div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} google map url </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={googleMapUrl}
                onChange={(e) => setgoogleMapUrl(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{urlErr}</div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
          </Row>
          <div className="btnContainer mt-4">
            <Button onClick={submit} title="SUBMIT" />
          </div>
        </Modal.Body>
      </Modal>
      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default ContactusBanner;

// updateBannerImages
